import React from 'react';

import { motion } from 'framer-motion';
import DOMPurify from 'isomorphic-dompurify';

import { framerCommon, titleVariants } from '../../framer.variants';
import { useCheckMobile } from '../../hooks';
import { data_use_instructions } from './content';
import { Icon1, Icon2, Icon3, Icon4 } from './framer.icons';

const icons = [<Icon1 />, <Icon2 />, <Icon3 />, <Icon4 />];

export default function GridBlocks({ id }) {
  // const isSmallForAnimation = useCheckMobile({ width: 1024 });
  const { prefix, title, items } = data_use_instructions;

  return (
    <section id={id} className="gl-wrapper gl-wrapper-y bg-black">
      <p className="gl-heading-3 text-demo-xr-blue">{prefix}</p>
      <h2 className="gl-heading-2 text-white">{title}</h2>
      {/*      <Icon1 />
      <Icon2 />
      <Icon3 />
      <Icon4 />*/}
      <div className="mt-11 grid grid-cols-2 gap-11 1100:gap-8 lg:mt-7 lg:grid-cols-1 lg:gap-6">
        {items.map((item, idx) => (
          <motion.div
            key={item.id}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 1.25, delay: 0 }}
            variants={{
              visible: { scale: 1 },
              hidden: { scale: 0.1 },
            }}
            className="col-span-1 flex w-full flex-col gap-5 overflow-hidden border border-demo-xr-blue bg-[rgba(0,163,255,0.10)] p-6 text-white even:justify-self-end lg:!scale-100 lg:!max-h-full lg:!w-full"
          >
            <div className="relative flex items-center gap-4 sm:flex-col sm:items-start">
              <div className="relative">
                <motion.div
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  transition={{ duration: 1.5, delay: 0.75 }}
                  variants={{
                    visible: {
                      scale: 1,
                      top: '0%',
                      left: '0%',
                      transform: 'translate(0%, 0%) scale(1)',
                    },
                    hidden: {
                      scale: 2.5,
                      top: '85%',
                      left: '85%',
                      transform: 'translate(50%, -50%) scale(2.5)',
                    },
                  }}
                  className="icon-frame-container absolute w-[8.125rem] lg:!left-0 lg:!top-0 lg:!scale-100 lg:!transform-none"
                >
                  {icons[idx]}
                </motion.div>

                <div className="h-[8.125rem] w-[8.125rem]" />
              </div>
              {/*<img className="aspect-square w-full max-w-[8.125rem] xlg:max-w-[96px]" src={item.image} alt="" />*/}
              <motion.h3
                {...framerCommon}
                variants={titleVariants}
                transition={{ duration: 1.5, delay: 2.5 }}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.title) }}
                className="gl-heading-3 relative leading-[1.12] text-white lg:static lg:!opacity-100"
              />
            </div>
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 1.5, delay: 2.5 }}
              variants={{
                visible: {
                  bottom: 0,
                  opacity: 1,
                },
                hidden: {
                  bottom: '-30%',
                  opacity: 0,
                },
              }}
              className="description relative font-OpenSans font-medium lg:!bottom-0 lg:!opacity-100"
            >
              {item.description}
            </motion.div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
